import {
  REQUEST_ORGANIZATIONS,
  RECEIVE_ORGANIZATIONS,
  SELECT_ORGANIZATION,
  CLEAN_ORGANIZATIONS,
  REQUEST_CURRENT_ORGANIZATION,
  RECEIVE_CURRENT_ORGANIZATION,
  REQUEST_CURRENT_ORG_FAILED
} from './organizations.actions';

export const organizationsInitialState: IOrganizationsState = {
  selectedOrganizationId: null,
  entities: {
    organizations: [],
  },
  result: undefined,
  isFetching: false,
  currentOrganization: undefined,
};

export function organizationsReducer(state = organizationsInitialState, action: any) {
  switch (action.type) {
    case REQUEST_ORGANIZATIONS:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_ORGANIZATIONS:
      const result = action.result;
      const selectedOrganization: any = Object.values(result.entities.organizations)
        .find((organization: any) => organization.userRole.role === 'owner' && organization.orgType === 'private')
      const selectedOrganizationId = selectedOrganization ? selectedOrganization.globalId : result.result.organizations[0];
      return Object.assign({}, state, result, {selectedOrganizationId}, {
        isFetching: false,
      });
    case RECEIVE_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        currentOrganization: action.result,
      });
    case SELECT_ORGANIZATION:
      return Object.assign({}, state, {}, {
        selectedOrganizationId: action.result,
      });
    case CLEAN_ORGANIZATIONS:
      return Object.assign({}, organizationsInitialState, {
        isFetching: false
      });
    case REQUEST_CURRENT_ORG_FAILED:
      return Object.assign({}, state, {
        currentOrganization: null,
      });
    default:
      return state;
  }
}

export interface IOrganizationsState {
  selectedOrganizationId: string,
  isFetching: boolean;
  entities: {
    organizations: IOrganizationInstance[],
  };
  result,
  currentOrganization: IOrganizationInstance,
}

export interface IOrganizationInstance {
  globalId: string;
  title: string;
  suspended: boolean;
}
